import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';

import {AuthProvider} from './context/AuthContext';
import './index.css';



const root = ReactDOM.createRoot(document.getElementById('root'));


/* Add this new font for the heavy titles */


root.render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<App/>
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>


);
